import { NotificationItem } from './NotificationItem'
import style from './Notifications.module.scss'
import { useNotification } from './notificationsHooks'
import { NoticeInState } from './store'

// уведомления на сайте
export function Notifications() {
  const notifications = useNotification()

  return (
    <div className={style.notificationsWrap}>
      <div className='container'>
        <div className={style.notificationsList}>
          {notifications?.map((noticeItem: NoticeInState) => (
            <NotificationItem key={noticeItem.id} notice={noticeItem} />
          ))}
        </div>
      </div>
    </div>
  )
}
